import { Dialog, DialogContent, DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { DialogConfig, DialogProps } from '../common/types'
import { DepositDialogContentContainer } from './DepositDialogContentContainer'
import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { TabSelector } from '@/ui/atoms/tab-selector/TabSelector'
import { useEffect, useState } from 'react'
import { useDisplayToken } from '@/domain/hooks/useDisplayToken'
import { SwapView } from './views/SwapView'
import { track } from '@/features/analytics'

enum DepositDialogTabs {
  Deposit = 'Deposit',
  Swap = 'Swap',
}

function DepositDialog({ token, open, setOpen }: DialogProps) {
  const isWrongNetwork = useWrongNetwork()
  const [activeTab, setActiveTab] = useState<DepositDialogTabs>(DepositDialogTabs.Deposit)
  const displayToken = useDisplayToken(token)

  useEffect(() => {
    track('lend_borrow_asset_selected', {
      token: token.symbol,
      market: token.address,
      market_type: 'standard',
      action_type: 'deposit',
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <DialogTitle>{`Deposit ${displayToken.symbol}`}</DialogTitle>

        <TabSelector
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={Object.values(DepositDialogTabs)}
          className="mt-2 mb-6 pb-2"
        />

        {activeTab === DepositDialogTabs.Deposit && (
          <DepositDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
        )}

        {activeTab === DepositDialogTabs.Swap && <SwapView token={token} />}
      </DialogContent>
    </Dialog>
  )
}

export const depositDialogConfig: DialogConfig<DialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: DepositDialog,
}
